import MuiTableRow from "@mui/material/TableRow";
const TableRow = MuiTableRow;
export default TableRow;
